import { AddressDetails } from '@app/interfaces/google-maps.interface';

/**
 * Transforms a complex Google Place response into a flat, readable AddressDetails structure.
 * This is a pure function designed for high testability and separation of concerns.
 * * @param place The Google Place object retrieved from the Places Library (New).
 * @returns A structured object containing street, number, city, state, and zip code.
 */
export const mapGoogleAddress = (place: google.maps.places.Place): AddressDetails => {
  const address: AddressDetails = { street: '', number: '', zipCode: '', city: '', state: '' };

  if (!place || !place.addressComponents) {
    return address;
  }

  place.addressComponents.forEach((component) => {
    const types = component.types;

    if (types.includes('route')) address.street = component.longText || '';
    if (types.includes('street_number')) address.number = component.longText || '';
    if (types.includes('administrative_area_level_1')) address.state = component.longText || '';
    if (types.includes('locality')) address.city = component.longText || '';
    if (types.includes('postal_code')) address.zipCode = component.longText || '';
  });

  return address;
};
